import Vue from 'vue'
import Ambiti from './Ambiti'
import Aziende from './Aziende'
import Allegati from './Allegati'
import Appuntamenti from './Appuntamenti'
import Argomenti from './Argomenti'
import Attrezzature from './Attrezzature'
import Categorie from './Categorie'
import Collaboratori from './Collaboratori'
import Controlli from './Controlli'
import Dipendenti from './Dipendenti'
import Dpi from './Dpi'
import FaseDpi from './FaseDpi'
import Ferie from './Ferie'
import Festivi from './Festivi'
import Fornitori from './Fornitori'
import GiorniApertura from './GiorniApertura'
import Impianti from './Impianti'
import Macchinari from './Macchinari'
import News from './News'
import Nomine from './Nomine'
import NoteInterne from './NoteInterne'
import NotificaScadenze from './NotificaScadenze'
import Parametri from './Parametri'
import Parazi from './Parazi'
import Prescrizioni from './Prescrizioni'
import Prodotti from './Prodotti'
import RegistroTitolare from './RegistroTitolare'
import Scadenze from './Scadenze'
import SorveglianzaCpi from './SorveglianzaCpi'
import TabControlli from './TabControlli'
import TabDefault from './TabDefault'
import TipRec from './TipRec'
import TipoConservazione from './TipoConservazione'
import TipoDipendenti from './TipoDipendenti'
import TipoDoc from './TipoDoc'
import TipoNomine from './TipoNomine'
import TipoScadenza from './TipoScadenza'
import TipoSegnalazione from './TipoSegnalazione'
import TipoVoce from './TipoVoce'
import CalendarioControlli from './CalendarioControlli'

const model = {
  'allegati': Allegati,
  'ambiti': Ambiti,
  'appuntamenti': Appuntamenti,
  'argomenti': Argomenti,
  'attrezzature': Attrezzature,
  'aziende': Aziende,
  'categoria': Categorie,
  'collaboratori': Collaboratori,
  'controlli': Controlli,
  'dipendenti': Dipendenti,
  'dpi': Dpi,
  'fase_dpi': FaseDpi,
  'ferie': Ferie,
  'festivi': Festivi,
  'fornitori': Fornitori,
  'giorni_apertura': GiorniApertura,
  'impianti': Impianti,
  'macchinari': Macchinari,
  'news': News,
  'nomine': Nomine,
  'note_interne': NoteInterne,
  'notifica_scadenze': NotificaScadenze,
  'parametri': Parametri,
  'parazi': Parazi,
  'prescrizioni': Prescrizioni,
  'prodotti': Prodotti,
  'registro_titolare': RegistroTitolare,
  'scadenze': Scadenze,
  'sorveglianza_cpi': SorveglianzaCpi,
  'tabcontrolli': TabControlli,
  'tabdefault': TabDefault,
  'tiprec': TipRec,
  'tipo_conservazione_dati': TipoConservazione,
  'tipo_dipendenti': TipoDipendenti,
  'tipo_doc': TipoDoc,
  'tipo_nomine': TipoNomine,
  'tipo_scadenza': TipoScadenza,
  'tipo_segnalazione': TipoSegnalazione,
  'tipo_voce': TipoVoce,
  'dettaglio_controlli': CalendarioControlli
}

export const bootstrap = async () => {
  Vue.use({
    install (Vue) {
      Vue.prototype.$model = model
    }
  })
}

export default model
